import { Pcr } from '../../lib/types/models/pcr/pcr'
import {
  AssignPcrInput,
  AssignPcrRequest
} from '../../lib/types/models/staff-application/staff-application-input'
import { IdsInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function assignToPcr(data: IdsInput<AssignPcrInput>) {
  return restApiClient
    .url(constructApiUrl(API.candidate.assignToPcr.url, null))
    .post<Pcr, IdsInput<AssignPcrRequest>>({
      ids: data.ids,
      pcrId: data.pcr.id,
      priority: data.priority
    })
}
